module.exports = __webpack_public_path__ + "img/kaola.481081b3.gif";